export default __webpack_public_path__ + "static/media/welcome-banner_desktop.daf7bc07.png";